var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgProperty = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 380,
    viewBox: "0 0 380 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2800_14194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.667 181.667V115H148.333V148.333H115V265H181.667V231.667H198.333V265H265V181.667H231.667ZM148.333 248.333H131.667V231.667H148.333V248.333ZM148.333 215H131.667V198.333H148.333V215ZM148.333 181.667H131.667V165H148.333V181.667ZM181.667 215H165V198.333H181.667V215ZM181.667 181.667H165V165H181.667V181.667ZM181.667 148.333H165V131.667H181.667V148.333ZM215 215H198.333V198.333H215V215ZM215 181.667H198.333V165H215V181.667ZM215 148.333H198.333V131.667H215V148.333ZM248.333 248.333H231.667V231.667H248.333V248.333ZM248.333 215H231.667V198.333H248.333V215Z",
    fill: "#E9E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2800_14194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 380,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProperty);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/property.a36c824009b05668e807b37c0dd8de1e.svg";